"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidderService = exports.SaveFix = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const angular2_moment_1 = require("angular2-moment");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
const integration_service_1 = require("./integration.service");
const version_pipe_1 = require("./version.pipe");
const loading_service_1 = require("./loading.service");
//local class fix
class SaveFix {
}
exports.SaveFix = SaveFix;
let BidderService = class BidderService {
    constructor(_http, _talk, _integration, _datePipe, _version, _loading) {
        this._http = _http;
        this._talk = _talk;
        this._integration = _integration;
        this._datePipe = _datePipe;
        this._version = _version;
        this._loading = _loading;
        this.adUnitGroups = [];
        this.adUnits = [];
        this.bidderURL = "/list";
        this.bidderInfoURL = "/bidder/";
        this.biddersURL = "/bidders";
        this.bidderAdUnitsURL = "/bidderAdUnits";
        this.saveBidderURL = "/save";
        this.adLockURL = "/bidderlock";
        this.bidderId = 0;
    }
    pull() {
        return this._http
            .get(this.bidderURL)
            .toPromise()
            .then((response) => {
            this.bidders = this.sanitizeBidders(response.json());
            // Note: Leaving ad groups inits here for now, but once the adunits are not populated for all bidders on /list,
            // we may instead call these method when the bidder its clicked to be loaded to the controlcenter/edit.
            // which may require a few other changes on services calling getAdUnitGroups
            this.adUnitGroups = this.initBiddersAdUnitGroups(this.bidders);
            return true;
        })
            .catch((err) => {
            this.bidders = null;
            return err;
        });
    }
    get() {
        return this.bidders;
    }
    getBidders() {
        return this._http
            .get(this.biddersURL)
            .toPromise()
            .then((response) => {
            this.bidders = this.sanitizeBidders(response.json().bidders);
            this.versionMapping = response.json().versionMapping;
            return true;
        })
            .catch((err) => {
            this.bidders = null;
            this.versionMapping = [];
            return err;
        });
    }
    getBidderDetail(bidderId) {
        return this._http
            .get(this.bidderInfoURL + bidderId)
            .toPromise()
            .then((response) => {
            this.bidder = this.sanitizeBidders([response.json()])[0];
            return this.bidder;
        })
            .catch((err) => {
            this.bidder = null;
            return err;
        });
    }
    getEngine2pbMap() {
        return this.versionMapping ? this.versionMapping : [];
    }
    initBiddersAdUnitGroups(bidders = []) {
        return bidders && bidders.length
            ? bidders.map((bidder) => ({
                displayName: bidder.name || "",
                // we only require ad codes
                adUnits: bidder.adUnits && bidder.adUnits.length
                    ? bidder.adUnits.map((ad) => ad.code)
                    : [],
            }))
            : [];
    }
    sanitizeBidders(bidders = []) {
        if (bidders && bidders.length) {
            for (let b in bidders) {
                if (bidders[b].client && bidders[b].client.integration) {
                    bidders[b].client.integration = this._integration.getIntegration(bidders[b].client.integration);
                }
                bidders[b].updatedAt = bidders[b].updatedAt
                    ? JSON.parse(this._datePipe.transform(bidders[b].updatedAt, "x"))
                    : "";
                bidders[b].updatedEmail = bidders[b].updatedBy
                    ? bidders[b].updatedBy.email || ""
                    : "";
            }
        }
        return bidders;
    }
    fetchBidderAdUnits() {
        return this._http
            .get(this.bidderAdUnitsURL)
            .toPromise()
            .then((response) => {
            let bidders = this.sanitizeBidders(response.json());
            bidders.forEach((bidder) => {
                bidder.adUnits.forEach((adUnit) => {
                    this.adUnits.push(adUnit);
                });
            });
            return Promise.resolve(this.adUnits);
        })
            .catch((err) => {
            this.adUnits = [];
            Promise.reject(err);
        });
    }
    fetchBidderAdUnitGroups() {
        return this._http
            .get(this.bidderAdUnitsURL)
            .toPromise()
            .then((response) => {
            let bidders = this.sanitizeBidders(response.json());
            this.adUnitGroups = this.initBiddersAdUnitGroups(bidders);
            Promise.resolve();
        })
            .catch((err) => {
            this.adUnitGroups = [];
            Promise.reject(err);
        });
    }
    getAdUnitGroups() {
        return JSON.parse(JSON.stringify(this.adUnitGroups));
    }
    getBidder(id) {
        for (var i in this.bidders) {
            if (this.bidders[i].id == id) {
                return JSON.parse(JSON.stringify(this.bidders[i]));
            }
        }
    }
    newBidder() {
        var ret = 0;
        for (var i in this.bidders) {
            if (this.bidders[i].id > ret) {
                ret = this.bidders[i].id;
            }
        }
        ret++;
        return ret;
    }
    save(load) {
        return this._http
            .post(this.saveBidderURL, load)
            .toPromise()
            .then((response) => response.json());
    }
    adLock(adID, lock) {
        return this._http
            .post(this.adLockURL, { bidder: adID, enabled: lock })
            .toPromise()
            .then((res) => {
            for (let b in this.bidders) {
                if (this.bidders[b].id === adID) {
                    if (this.bidders[b].lock)
                        this.bidders[b].lock.enabled = lock;
                    else
                        this.bidders[b].lock = { enabled: lock };
                }
            }
        })
            .catch((err) => {
            this._talk.broadcast(`Oops. It looks like there was an issue changing the lock status of this Bidder <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>` +
                err);
        });
    }
    compare(id, bidderToSave) {
        if (id) {
            let differences = [];
            //create json copies and their keys
            let saveBidder = this.bidder;
            let saveBidderKeys = Object.keys(saveBidder);
            let newBidder = bidderToSave;
            let newBidderKeys = Object.keys(newBidder);
            let saveBidderAUs = saveBidder.adUnits;
            let newBidderAUs = newBidder.adUnits;
            //Omitting compare for this keys;
            let keyToBypass = [
                "id",
                "client",
                "name",
                "createdBy",
                "updatedBy",
                "server",
                "adUnits",
                "server",
                "integrations",
                "schainConfig",
                "sizeGUID",
                "bidderGUID",
            ];
            for (let adUnit in saveBidderAUs) {
                let aUDifferences = [];
                let saveAU = saveBidderAUs[adUnit];
                let newAU = newBidderAUs.filter((r) => {
                    if (saveAU.name == r.name) {
                        return r;
                    }
                });
                //check to see if any new ad units have been created :: uses name as a unique parameter
                for (let newBidderAU in newBidderAUs) {
                    let nAU = newBidderAUs[newBidderAU];
                    let createdDP = saveBidderAUs.filter((r) => {
                        return JSON.stringify(r.name) == JSON.stringify(nAU.name);
                    });
                    let newAUAdded = differences.some((difference) => difference.difference.after.name === nAU.name);
                    if (createdDP.length == 0 && !newAUAdded) {
                        differences.push({
                            changeLocation: "Ad Units: " + newAU.name,
                            difference: {
                                changeText: "New Ad Unit created :: " + nAU.name,
                                before: "",
                                after: nAU,
                            },
                        });
                    }
                }
                //check to see if any ad units have been deleted :: uses name as a unique parameter
                if (newAU.length == 0) {
                    differences.push({
                        changeLocation: "Ad Units: " + saveAU.name,
                        difference: {
                            changeText: "Ad unit deleted :: " + saveAU.name,
                            before: saveAU,
                            after: "",
                        },
                    });
                    continue;
                }
                if (newAU.length) {
                    newAU = newAU[0];
                    if (JSON.stringify(saveAU) == JSON.stringify(newAU)) {
                        continue;
                    }
                    if (saveAU.div != newAU.div) {
                        aUDifferences.push({
                            changeLocation: "Ad Units " + newAU.name,
                            difference: {
                                changeText: "Ad Unit Div ID changed.",
                                before: saveAU.div,
                                after: newAU.div,
                            },
                        });
                    }
                    if (saveAU.code != newAU.code) {
                        aUDifferences.push({
                            changeLocation: "Ad Units " + newAU.name,
                            difference: {
                                changeText: "Ad Unit Code changed.",
                                before: saveAU.code,
                                after: newAU.code,
                            },
                        });
                    }
                    if (JSON.stringify(saveAU.sizes) != JSON.stringify(newAU.sizes)) {
                        aUDifferences.push({
                            changeLocation: "Ad Units " + newAU.name,
                            id: "sizes",
                            difference: {
                                changeText: "Ad Unit Sizes changed.",
                                before: saveAU.sizes,
                                after: newAU.sizes,
                            },
                        });
                    }
                    if (saveAU.sizeMapping) {
                        if (JSON.stringify(saveAU.sizeMapping) !=
                            JSON.stringify(newAU.sizeMapping)) {
                            aUDifferences.push({
                                changeLocation: "Ad Units " + newAU.name,
                                difference: {
                                    changeText: "Ad Unit Size Mapping changed.",
                                    before: saveAU.sizeMapping,
                                    after: newAU.sizeMapping,
                                },
                            });
                        }
                    }
                    let saveDPs = saveAU.demandPartners;
                    let newDPs = newAU.demandPartners;
                    if (saveDPs && newDPs) {
                        for (let newDP in newDPs) {
                            let nDP = newDPs[newDP];
                            let createdDP = saveDPs.filter((r) => {
                                return JSON.stringify(r.params) == JSON.stringify(nDP.params);
                            });
                            if (createdDP.length == 0) {
                                aUDifferences.push({
                                    changeLocation: "Ad Units: " + newAU.name,
                                    difference: {
                                        changeText: "New demand partner bidder added to " +
                                            newAU.name +
                                            " :: " +
                                            nDP.bidder,
                                        before: "",
                                        after: nDP,
                                    },
                                });
                            }
                        }
                        for (let saveDP in saveDPs) {
                            let sDP = saveDPs[saveDP];
                            let nDPs = newDPs.filter((r) => {
                                if (JSON.stringify(r.params) == JSON.stringify(sDP.params)) {
                                    return r;
                                }
                            });
                            //only demand partners bidders in excess of one can be deleted, the first bidder for a demand partner will be deactivated and it's params will be saved
                            if (nDPs.length == 0) {
                                aUDifferences.push({
                                    changeLocation: "Ad Units: " + newAU.name,
                                    difference: {
                                        changeText: "Change in ad unit " +
                                            newAU.name +
                                            " :: Demand Partner bidder " +
                                            sDP.bidder +
                                            " deleted.",
                                        before: sDP,
                                        after: "",
                                    },
                                });
                                continue;
                            }
                            for (let nDP in nDPs) {
                                let newDP = nDPs[nDP];
                                if (JSON.stringify(sDP.params) != JSON.stringify(newDP.params) ||
                                    sDP.enabled != newDP.enabled) {
                                    if (sDP.enabled == false && newDP.enabled == true) {
                                        aUDifferences.push({
                                            changeLocation: "Ad Units: " + newAU.name,
                                            difference: {
                                                changeText: "Change in ad unit " +
                                                    newAU.name +
                                                    " :: demand partner " +
                                                    newDP.bidder +
                                                    " enabled.",
                                                before: sDP,
                                                after: newDP,
                                            },
                                        });
                                    }
                                    else if (sDP.enabled == true && newDP.enabled == false) {
                                        aUDifferences.push({
                                            changeLocation: "Ad Units: " + newAU.name,
                                            difference: {
                                                changeText: "Change in ad unit " +
                                                    newAU.name +
                                                    " :: demand partner " +
                                                    newDP.bidder +
                                                    " disabled.",
                                                before: sDP,
                                                after: newDP,
                                            },
                                        });
                                    }
                                }
                            }
                        }
                    }
                    if (aUDifferences.length > 0) {
                        aUDifferences.map((r) => {
                            return differences.push(r);
                        });
                        //if no change to matched ad unit or recognized changes were made to a matched ad unit, remove ad units from arrays
                        continue;
                    }
                }
            }
            for (let bidderKey in newBidderKeys) {
                let key = newBidderKeys[bidderKey];
                let nBidderItem = newBidder[key];
                let sBidderItem = saveBidder[key];
                switch (true) {
                    case keyToBypass.includes(key):
                        break;
                    case typeof nBidderItem == "boolean":
                        if ((nBidderItem == true) != (sBidderItem == true)) {
                            differences.push({
                                changeLocation: "Advanced Options: " + key,
                                difference: {
                                    changeText: key + " has been set to :: " + nBidderItem,
                                    before: sBidderItem,
                                    after: nBidderItem,
                                },
                            });
                        }
                        break;
                    case key == "controlCenterVersion" || key == "engineVersion":
                        if (JSON.stringify(nBidderItem) != JSON.stringify(sBidderItem)) {
                            differences.push({
                                changeLocation: "Advanced Options: " + key,
                                difference: {
                                    changeText: "Versions have been changed",
                                    before: sBidderItem,
                                    after: nBidderItem,
                                },
                            });
                        }
                        break;
                    case key == "timeout":
                        if (nBidderItem != sBidderItem) {
                            differences.push({
                                changeLocation: "Advanced Options: " + key,
                                difference: {
                                    changeText: "Timeout has been changed to " + nBidderItem,
                                    before: sBidderItem,
                                    after: nBidderItem,
                                },
                            });
                        }
                    case key == "hardFloor":
                        if (nBidderItem == 0 && sBidderItem == "undefined") {
                            break;
                        }
                        if (nBidderItem != sBidderItem) {
                            differences.push({
                                changeLocation: "Advanced Options: " + key,
                                difference: {
                                    changeText: "Hard Floor has been updated to " + nBidderItem,
                                    before: sBidderItem,
                                    after: nBidderItem,
                                },
                            });
                        }
                        break;
                    case key == "bidAdjustments":
                        let nBidReductions = Object.keys(nBidderItem || {});
                        let sBidReductions = Object.keys(sBidderItem || {});
                        if (nBidReductions.length != sBidReductions.length) {
                            let diff = this.existsInArray(nBidReductions, sBidReductions);
                            for (let d in diff) {
                                if (diff[d][0] == "created") {
                                    if (diff[d][1] == "server" &&
                                        Object.keys(nBidderItem[nBidReductions[0]]).length == 0) {
                                        continue;
                                    }
                                    let change = {};
                                    change[diff[d][1]] = nBidderItem[diff[d][1]];
                                    differences.push({
                                        changeLocation: "Advanced Options: " + key,
                                        difference: {
                                            changeText: "Bid Reduction " +
                                                diff[d][1] +
                                                " has been " +
                                                diff[d][0],
                                            before: "",
                                            after: change,
                                        },
                                    });
                                }
                                if (diff[d][0] == "deleted") {
                                    let change = {};
                                    change[diff[d][1]] = nBidderItem[diff[d][1]];
                                    differences.push({
                                        changeLocation: "Advanced Options: " + key,
                                        difference: {
                                            changeText: "Bid Reduction " +
                                                diff[d][1] +
                                                " has been " +
                                                diff[d][0],
                                            before: change,
                                            after: "",
                                        },
                                    });
                                }
                            }
                            break;
                        }
                        for (let reductionKey in nBidReductions) {
                            let nBidReduction = nBidReductions[reductionKey];
                            if (reductionKey == "server") {
                                if (!sBidderItem.nBidReduction &&
                                    Object.keys(nBidderItem.nBidReduction || {}).length > 0) {
                                    if (JSON.stringify(nBidderItem[nBidReduction]) !=
                                        JSON.stringify(sBidderItem[sBidReductions[reductionKey]])) {
                                        differences.push({
                                            changeLocation: "Advanced Options: " + key,
                                            difference: {
                                                changeText: "Server Bid Reductions has been changed",
                                                before: saveBidder.bidReductions[nBidReduction],
                                                after: newBidder.bidReductions[nBidReduction],
                                            },
                                        });
                                    }
                                }
                            }
                            else {
                                if (JSON.stringify(nBidderItem[nBidReduction]) !=
                                    JSON.stringify(sBidderItem[sBidReductions[reductionKey]])) {
                                    differences.push({
                                        changeLocation: "Advanced Options: " + key,
                                        difference: {
                                            changeText: reductionKey + " Bid Reduction has been changed",
                                            before: sBidderItem[nBidReduction],
                                            after: nBidderItem[nBidReduction],
                                        },
                                    });
                                }
                            }
                        }
                        break;
                    case key == "priceBuckets":
                        if (sBidderItem[0].pbi || sBidderItem[0].tier) {
                            sBidderItem.map((r) => {
                                delete r.pbi;
                                delete r.tier;
                            });
                        }
                        if (JSON.stringify(nBidderItem) != JSON.stringify(sBidderItem)) {
                            differences.push({
                                changeLocation: "Advanced Options: " + key,
                                difference: {
                                    changeText: "Price Buckets have been changed",
                                    before: sBidderItem,
                                    after: nBidderItem,
                                },
                            });
                        }
                        break;
                    default:
                        console.error("Unknown Bidder JSON key " + key);
                        break;
                }
            }
            return differences;
        }
    }
    existsInArray(newItem, oldItem) {
        let diff = [];
        for (let i in newItem) {
            if (oldItem.indexOf(newItem[i]) == -1) {
                diff.push(["created", newItem[i]]);
            }
        }
        for (let i in oldItem) {
            if (newItem.indexOf(oldItem[i]) == -1) {
                diff.push(["deleted", oldItem[i]]);
            }
        }
        return diff;
    }
    restore(adID) {
        return this._http
            .post("/bidder/restore/" + adID)
            .toPromise()
            .then((res) => {
            if (res.status !== 200) {
                throw new Error("Unable to restore bid");
            }
            return this.getBidders().then((err) => {
                return res.statusText;
            });
        })
            .catch((err) => {
            this._talk.broadcast("Oops. It looks like we had problem restoring this Bidder");
            return err;
        });
    }
    delete(adID) {
        return this._http
            .post("/bidder/delete/" + adID)
            .toPromise()
            .then((res) => {
            if (res.status !== 200) {
                throw new Error("Unable to delete Bidder");
            }
            return this.getBidders().then((err) => {
                return res.statusText;
            });
        })
            .catch((err) => {
            this._talk.broadcast("Oops. It looks like we had problem deleting this Bidder");
            return err;
        });
    }
    pause(adID) {
        return this._http
            .post("/bidder/pause/" + adID)
            .toPromise()
            .then((res) => {
            if (res.status !== 200) {
                throw new Error("Unable to pause Bidder");
            }
            return this.getBidders().then((err) => {
                return res.statusText;
            });
        })
            .catch((err) => {
            this._talk.broadcast("Oops. It looks like we had problem pausing this Bidder");
            return err;
        });
    }
    unpause(adID) {
        return this._http
            .post("/bidder/unpause/" + adID)
            .toPromise()
            .then((res) => {
            if (res.status !== 200) {
                throw new Error("Unable to unpause Bidder");
            }
            return this.getBidders().then((err) => {
                return res.statusText;
            });
        })
            .catch((err) => {
            this._talk.broadcast("Oops. It looks like we had problem unpausing this Bidder");
            return err;
        });
    }
    checkNewSizesChanges(compareData) {
        let changes = compareData
            ? compareData
                .filter((change) => change.id === "sizes")
                .reduce((newSizes, change) => {
                if (change.difference &&
                    change.difference.after &&
                    Array.isArray(change.difference.after)) {
                    // only check for new changes
                    if (!change.difference.before)
                        newSizes.push(change.difference.after);
                    else {
                        // check if its a new size
                        change.difference.after.forEach((newSize) => {
                            if (!change.difference.before.find((prevSize) => prevSize.toString() === newSize.toString())) {
                                newSizes.push(newSize);
                            }
                        });
                    }
                }
                return newSizes;
            }, [])
            : void 0;
        return changes;
    }
};
exports.BidderService = BidderService;
exports.BidderService = BidderService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService,
        integration_service_1.IntegrationService,
        angular2_moment_1.DateFormatPipe,
        version_pipe_1.VersionPipe,
        loading_service_1.LoadingService])
], BidderService);
//# sourceMappingURL=bidder.service.js.map